import React from 'react';
import Userall from './Userall';
import Adduser from './Adduser';
import axios from 'axios';
import Loader from '../../Loader';

class User extends React.Component {
    state = {
        users: [],
        spinner: true
    }

    componentDidMount() {
        this.getUsers();
    }

    getUsers = async () => {
        try {
            const response = await axios.get('users');
            if (response.status === 200) {
                this.setState({
                    users: response.data,
                    spinner: false
                });
            }
        } catch (error) {
            console.error('Error fetching users:', error);
        }
    };

    render() {
        const { users, spinner } = this.state;

        if (spinner) {
            return <Loader />;
        }

        return (
            <div className="adminx-content">
                <div className="adminx-main-content">  
                    <div className="container-fluid">
                        <nav aria-label="chapelure" role="navigation">
                            <ol className="breadcrumb adminx-page-breadcrumb">
                                <li className="breadcrumb-item"><a href="#">Accueil</a></li>
                                <li className="breadcrumb-item"><a href="#">Utilisateur</a></li>
                                <li className="breadcrumb-item active" aria-current="page">Gestion des utilisateurs</li>
                            </ol>
                        </nav>

                        <div className="pb-3 d-flex justify-content-between">
                            <h3>Gestion des utilisateurs</h3>
                            {/* <button type="button" className="btn btn-primary btn-sm" onClick={() => window.history.back()}>
                                <i className="bi bi-arrow-left-short"></i>
                                Retour
                            </button> */}
                        </div>

                        <div className="row">
                            <div className="col-lg-8">
                                <div className="card">
                                    <div className="card-header d-flex justify-content-between align-items-center">
                                        <div className="card-header-title">Liste des {users.length} utilisateurs</div>
                                    </div>
                                    <div className="card-body collapse show" id="card1">
                                        <Userall users={users} get={this.getUsers} />
                                    </div>
                                </div>
                            </div>

                            <div className="col-lg-4">
                                <div className="card">
                                    <div className="card-header">
                                        <div className="card-header-title">Ajouter un utilisateur</div>
                                    </div>
                                    <Adduser get={this.getUsers} />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default User;
